import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const TasksPage = lazy(() => import('@/pages/tasks'));
const SettingsTasksRedirect = lazy(async () => ({
  default: () => <Navigate to="/tasks" replace />,
}));

export const taskRoutes: RouteConfig[] = [
  {
    path: '/tasks',
    layout: DashboardLayout,
    element: TasksPage,
  },
  {
    path: '/settings/tasks',
    layout: DashboardLayout,
    element: SettingsTasksRedirect,
  },
];
